import { TranslateService } from '@ngx-translate/core';

export class GenderUtils {
  private static translateService: TranslateService;
  static async initializeTranslateService(service: TranslateService) {
    this.translateService = service;
  }

  private static readonly GENDERS: {
    [key: number]: { id: number; translationKey: string };
  } = {
      1: { id: 1, translationKey: 'other' },
      2: { id: 2, translationKey: 'male' },
      3: { id: 3, translationKey: 'female' },
    };

  static getAllGenders(): Array<{ id: number; name: string }> {
    if (!this.translateService) {
      return [];
    }

    return Object.values(this.GENDERS).map((gender) => ({
      id: gender.id,
      name: this.translateService.instant(gender.translationKey),
    }));
  }

  static translateGender(gender: string, lang: string): string {
    const formattedGender = gender?.toLowerCase();
    if (lang === 'en-US') {
      if (formattedGender === 'm') return 'M';
      else if (formattedGender === 'f') return 'F';
      else return 'O';
    } else if (lang === 'nl-NL') {
      if (formattedGender === 'm') return 'M';
      else if (formattedGender === 'f') return 'V';
      else return 'A';
    } else if (lang === 'tr-TR') {
      if (formattedGender === 'm') return 'E';
      else if (formattedGender === 'f') return 'K';
      else return 'D';
    }
    return '-';
  }
}
